import { MasterDataRepositoryInterface } from '@/data/persistences/repositories/contracts/MasterDataRepositoryInterface'
import { Reasons } from '@/domain/entities/MasterData'
import { injectable } from 'tsyringe'

@injectable()
export class MasterDataPresenter {
  private repository: MasterDataRepositoryInterface

  constructor(repository: MasterDataRepositoryInterface) {
    this.repository = repository
  }

  public getReasons(): Promise<Reasons> {
    return this.repository.getReasons()
  }
}
